<template>
    <div class="content">
        <div class="md-layout">
            <div class="md-layout-item ">
                <div class="custom-toolbar">
                    <div class="custom-toolbar-start">
                        <BillingAccountsFilter @onChanged="billingAccountsFilterChangedHandler" />
                    </div>
                    <div class="custom-toolbar-end">
                        <SearchComponent
                            v-if="$root.isDesktop"
                            :search-filter="searchText"
                            :placeholder="searchPlaceholder"
                            @onSearch="searchComponentSearchHandler"
                        />
                    </div>
                </div>
            </div>
        </div>
        <div class="md-layout">
            <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
                <md-card>
                    <md-card-header class="md-card-header-icon md-card-header-blue">
                        <div class="card-icon">
                            <md-icon>payment</md-icon>
                        </div>
                    </md-card-header>
                    <md-card-content>
                        <div class="row">
                            <template v-if="!searchResults || !searchResults.length">
                                <p>No result found.</p>
                            </template>
                            <template v-else>
                                <div class="column">
                                    <md-table>
                                        <md-table-row>
                                            <md-table-head>&nbsp;</md-table-head>
                                            <md-table-head>Company</md-table-head>
                                            <md-table-head>Team Status</md-table-head>
                                            <md-table-head>Billing Status</md-table-head>
                                            <md-table-head>Free Users Allowed</md-table-head>
                                            <md-table-head>Active User</md-table-head>
                                            <md-table-head>Licensed User</md-table-head>
                                            <md-table-head>&nbsp;</md-table-head>
                                        </md-table-row>
                                        <md-table-row
                                            v-for="(item, itemIndex) in searchResults"
                                            :key="`result-${itemIndex}`"
                                        >
                                            <md-table-cell>
                                                {{ ++itemIndex + (pagination.currentPage - 1) * pagination.perPage }}
                                            </md-table-cell>
                                            <md-table-cell>
                                                {{ item.company }}
                                            </md-table-cell>
                                            <md-table-cell>
                                                {{ item.teamStatus }}
                                            </md-table-cell>
                                            <md-table-cell>
                                                {{ item.billingStatus }}
                                                <template v-if="item.billingStatus === 'free'">
                                                    <br />
                                                    <i v-if="item.freeUntilDate">
                                                        <span>
                                                            until
                                                            {{
                                                                item.freeUntilDate
                                                                    | dateFormat(DATE_TYPES.internationalDate)
                                                            }}
                                                        </span>
                                                    </i>
                                                </template>
                                            </md-table-cell>
                                            <md-table-cell>
                                                {{
                                                    item.billingStatus === 'free' && item.freeUsersAllowed
                                                        ? item.freeUsersAllowed
                                                        : '-'
                                                }}
                                            </md-table-cell>
                                            <md-table-cell>
                                                {{ item.activeUsers }}
                                            </md-table-cell>
                                            <md-table-cell>
                                                {{ item.licensedUsers ? item.licensedUsers : '-' }}
                                            </md-table-cell>
                                            <md-table-cell>
                                                <md-button
                                                    title="Change Status"
                                                    class="md-info md-just-icon md-round md-primary"
                                                    @click.prevent="openChangeStatus(item)"
                                                >
                                                    <md-icon>flip</md-icon>
                                                </md-button>
                                                <md-button
                                                    title="Set as free"
                                                    class="md-info md-just-icon md-round md-primary"
                                                    @click.prevent="openSetAsFree(item)"
                                                >
                                                    <md-icon>money_off_csred</md-icon>
                                                </md-button>
                                                <md-button
                                                    title="Update pricing"
                                                    class="md-info md-just-icon md-round md-primary"
                                                    @click.prevent="openPricing(item)"
                                                >
                                                    <md-icon>price_change</md-icon>
                                                </md-button>
                                                <md-button
                                                    title="View Details"
                                                    class="md-info md-just-icon md-round md-primary"
                                                    @click.prevent="openDetails(item)"
                                                >
                                                    <md-icon>payment</md-icon>
                                                </md-button>
                                            </md-table-cell>
                                        </md-table-row>
                                    </md-table>
                                </div>
                            </template>
                        </div>
                    </md-card-content>
                    <md-card-actions v-if="total" class="page-footer" md-alignment="space-between">
                        <div>
                            <p v-if="total === pagination.perPage" class="card-category">
                                Page {{ pagination.currentPage }} of many
                            </p>
                            <p v-else class="card-category">Page {{ pagination.currentPage }} of {{ totalPages }}</p>
                        </div>
                        <Pagination
                            v-model="pagination.currentPage"
                            class="pagination-no-border pagination-success"
                            :per-page="pagination.perPage"
                            :total="total"
                            :enable-first-page-link="true"
                            :enable-last-page-link="true"
                            @change-page="handleChangePage($event, pagination.perPage)"
                        />
                    </md-card-actions>
                </md-card>
            </div>
        </div>
    </div>
</template>

<script>
import { handleRequests, showErrorMessage } from '@/helpers';
import { GeneralMixin } from '@/mixins/GeneralMixin';
import { Pagination, SearchComponent } from '@/components';
import BillingAccountsFilter from './components/BillingAccountsFilter';
import UpdateProductPricingModal from './components/UpdateProductPricingModal';
import SetFreeModal from './components/SetFreeModal';
import ChangeTeamStatusModal from './components/ChangeTeamStatusModal';

export default {
    name: 'BillingAccounts',
    components: { SearchComponent, Pagination, BillingAccountsFilter },
    mixins: [GeneralMixin],
    data() {
        return {
            searchText: '',
            filters: {
                findBy: 'team',
                teamStatus: 'Active',
                billingStatus: ''
            },
            searchResults: [],
            pagination: {
                perPage: 50,
                currentPage: 1,
                total: 0
            }
        };
    },
    computed: {
        total() {
            return this.pagination.total;
        },
        totalPages() {
            if (this.total > 0) {
                return Math.ceil(this.total / this.pagination.perPage);
            }
            return 1;
        },
        searchPlaceholder() {
            return this.filters.findBy === 'team' ? 'company' : 'company, email, name';
        }
    },
    methods: {
        async handleChangePage(currentPage = 1, perPage = 50) {
            this.pagination.currentPage = currentPage;
            this.pagination.perPage = perPage;

            await this.getLicenses();
        },
        async searchComponentSearchHandler(arg) {
            this.searchText = arg?.searchText ?? '';

            this.pagination.currentPage = 1;
            await this.getLicenses();
        },
        async billingAccountsFilterChangedHandler(args) {
            this.filters = { ...args };
            this.pagination.currentPage = 1;
            await this.getLicenses();
        },
        async getLicenses() {
            this.$_handleLoaderState(true, 'Fetching licenses');
            try {
                const payload = {
                    method: 'POST',
                    data: {
                        findBy: this.filters?.findBy ?? 'team',
                        teamStatus: this.filters?.teamStatus ?? '',
                        billingStatus: this.filters?.billingStatus ?? '',
                        searchText: this.searchText,
                        pageNumber: this.pagination.currentPage,
                        itemsPerPage: this.pagination.perPage
                    }
                };
                const api = `/api/billings/support/license-summary`;

                const { data } = await handleRequests(api, payload);

                if (data?.data && data.data.length) {
                    this.searchResults = [...data.data];
                    this.pagination.total = data.total;
                } else {
                    this.searchResults = [];
                    this.pagination.total = 0;
                }
            } catch (e) {
                const message = 'Unable to retrieve licenses.';
                showErrorMessage(this, message, e);
            } finally {
                this.$_handleLoaderState(false);
            }
        },
        openDetails(license) {
            const qry = new URLSearchParams();

            if (license.teamId) {
                qry.append('teamId', license.teamId);
            }

            const url = `/billing/account-details?${qry}`;
            window.open(url, '_blank');
        },
        openPricing(item) {
            this.$modal.show(UpdateProductPricingModal, { teamId: item.teamId, company: item.company }).then(() => {
                this.$modal.hide();
            });
        },
        openSetAsFree(item) {
            this.$modal
                .show(SetFreeModal, {
                    teamId: item.teamId,
                    company: item.company,
                    freeUntilDate: item.freeUntilDate,
                    freeUsersAllowed: item.freeUsersAllowed
                })
                .then((updated) => {
                    this.$modal.hide();
                    if (updated) {
                        const ndx = this.searchResults.findIndex((x) => x.teamId === item.teamId);
                        const updatedModel = this.searchResults[ndx];
                        updatedModel.freeUntilDate = updated.freeUntilDate;
                        updatedModel.freeUsersAllowed = updated.freeUsersAllowed;
                        this.$set(this.searchResults, ndx, updatedModel);
                    }
                });
        },
        openChangeStatus(item) {
            this.$modal
                .show(ChangeTeamStatusModal, {
                    teamId: item.teamId,
                    company: item.company,
                    teamStatus: item.teamStatus
                })
                .then((updated) => {
                    this.$modal.hide();
                    if (updated) {
                        const ndx = this.searchResults.findIndex((x) => x.teamId === item.teamId);
                        const updatedModel = this.searchResults[ndx];
                        updatedModel.teamStatus = updated.status;
                        this.$set(this.searchResults, ndx, updatedModel);
                    }
                });
        }
    },
    async mounted() {
        this.getLicenses();
    }
};
</script>

<style lang="scss" scoped>
.md-just-icon {
    margin-right: 2px;
}
</style>
